module.exports = __webpack_public_path__ + "img/halfStar.f1f88994.svg";